export default __webpack_public_path__ + "static/media/b2.20e18e09.jpg";